/**
 * Body Reapers — hover product-card image carousel (2026-07-04)
 * Task: arslaan-homepage-card-restyle-20260704 (feature add)
 * Self-contained, delegated click handling. Arrow clicks NEVER navigate —
 * every handler calls preventDefault + stopPropagation before doing
 * anything else, and the slide <a> tags are only real links when a
 * customer clicks the photo itself (not the arrow/dot controls).
 */
(function () {
  /*
   * MOBILE WEIGHT FIX 2026-08-16. product-card.liquid now emits a real <img> for slide 1 only;
   * slides 2-6 arrive as empty <a> tags carrying data-br-src. Build them on first desktop intent
   * (hover, focus, or an arrow press). Phones never reach this: the carousel is display:none under
   * (hover: none)/(pointer: coarse), which is exactly why ~875KB per page was being wasted.
   *
   * Idempotent and defensive: if this JS never runs, slide 1 still shows and every slide is still
   * a working link to the product, so the card degrades to a single image rather than breaking.
   */
  function hydrate(carousel) {
    if (!carousel || carousel.getAttribute('data-br-hydrated') === '1') return;
    carousel.setAttribute('data-br-hydrated', '1');
    var pending = carousel.querySelectorAll('.br-card-carousel__slide[data-br-src]');
    Array.prototype.forEach.call(pending, function (slide) {
      if (slide.querySelector('img')) return;
      var img = document.createElement('img');
      img.className = 'br-card-carousel__image';
      img.alt = slide.getAttribute('data-br-alt') || '';
      img.setAttribute('loading', 'lazy');
      img.src = slide.getAttribute('data-br-src');
      slide.appendChild(img);
    });
  }

  function hydrateFrom(target) {
    if (!target || typeof target.closest !== 'function') return;
    hydrate(target.closest('[data-br-card-carousel]'));
  }

  // Hover is the desktop trigger. mouseover fires before click, so arrows are already populated by
  // the time anyone can press one. pointerenter/focusin cover pen input and keyboard tabbing.
  document.addEventListener('mouseover', function (e) { hydrateFrom(e.target); }, true);
  document.addEventListener('focusin', function (e) { hydrateFrom(e.target); }, true);

  function activate(carousel, index) {
    var slides = carousel.querySelectorAll('.br-card-carousel__slide');
    var dots = carousel.querySelectorAll('.br-card-carousel__dot');
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    carousel.setAttribute('data-active-index', String(index));
  }

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-br-carousel-prev]');
    var nextBtn = e.target.closest('[data-br-carousel-next]');
    if (!prevBtn && !nextBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var carousel = (prevBtn || nextBtn).closest('[data-br-card-carousel]');
    if (!carousel) return;
    // Belt and braces: if hover somehow never fired, build the slides before advancing so an arrow
    // press can never land on an empty slide.
    hydrate(carousel);
    var current = parseInt(carousel.getAttribute('data-active-index') || '0', 10);
    activate(carousel, prevBtn ? current - 1 : current + 1);
  }, true);
})();
